import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import LandingPage from './views/LandingPage/LandingPage';
import CreateBook from './views/CreateBook/CreateBook';
import CreateOptions from './views/CreateOptions/CreateOptions';
import StoryPrompt from './views/StoryPrompt/StoryPrompt';
import StoryReview from './views/StoryPrompt/StoryReview';
import Privacy from './views/Privacy/Privacy';
import Terms from './views/Terms/Terms';
import { Login } from './components/Login/Login';
import { SignUp } from './components/Login/SignUp';
import { ForgotPassword } from './components/Login/ForgotPassword';
import { UserProvider } from './contexts/UserContext';
import { NavigationProvider } from './contexts/NavigationContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Profile from './components/Profile';

// Separate component for the main app content
function AppContent() {
  const location = useLocation();

  React.useEffect(() => {
    document.title = "Child Story Time";
    
    if (location.hash === '#pricing-section') {
      setTimeout(() => {
        const pricingSection = document.getElementById('pricing-section');
        if (pricingSection) {
          pricingSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div className="App">
      <Navbar />

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        } />
        <Route
          path="/create"
          element={
            <ProtectedRoute>
              <CreateOptions />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/create/1-write" 
          element={
            <ProtectedRoute>
              <CreateBook />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/create/2-preferences" 
          element={
            <ProtectedRoute>
              <StoryPrompt />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/create/3-review" 
          element={
            <ProtectedRoute>
              <StoryReview />
            </ProtectedRoute>
          }
        />
      </Routes>

      <Footer />
    </div>
  );
}

// Main App component
function App() {
  return (
    <GoogleOAuthProvider 
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}
        onScriptLoadError={() => console.error('Google Script failed to load')}
    >
        <Router>
            <UserProvider>
                <NavigationProvider>
                    <AppContent />
                </NavigationProvider>
            </UserProvider>
        </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
